import React from 'react';
import ReactDOM from 'react-dom';
import LoginForm from './LoginForm';
import BigtimeLoginForm from './BigtimeLoginForm';
import {BrowserRouter, Routes, Route, Link} from "react-router-dom";
import Events from "./Events";
import EditEvent from "./EditEvent";
import DeleteEvent from "./DeleteEvent";
import DuplicateEvent from "./DuplicateEvent";
import Projects from "./Projects";
import EditProject from "./EditProject";
import WeekReport from "./WeekReport";
import BigtimeEntriesReport from "./BigtimeEntriesReport";
import Notes from "./Notes";
import './main.css';

export default function App() {
  let token = window.localStorage.getItem('token');
  console.log('token', token);
  return (
    <BrowserRouter>
      <Link to="/">Events</Link> &nbsp; 
      <Link to="/projects">Projects</Link> &nbsp; 
      <Link to="/week">Week</Link> &nbsp; 
      <Link to="/login">Log out</Link> &nbsp; 
      <Link to="/bigtimeLogin">Bigtime login</Link> &nbsp; 
      <Link to="/bigtimeEntries">Bigtime entries</Link> &nbsp; 
      <Link to="/notes">Notes</Link> &nbsp;

      <hr />

      <Routes>
        <Route exact path="/events/:dateParam" element={<Events/>}/>
        <Route exact path="/events" element={<Events/>}/>
        <Route exact path="/edit/:eventIdParam" element={<EditEvent/>}/>
        <Route exact path="/edit" element={<EditEvent/>}/>
        <Route exact path="/delete/:eventIdParam" element={<DeleteEvent/>}/>
        <Route exact path="/duplicate/:eventIdParam" element={<DuplicateEvent/>}/>
        <Route exact path="/projects/:projectId" element={<Projects/>}/>
        <Route exact path="/projects" element={<Projects/>}/>
        <Route exact path="/project/:projectIdParam" element={<EditProject/>}/>
        <Route exact path="/project" element={<EditProject/>}/>
        <Route exact path="/week/:dateParam" element={<WeekReport/>}/>
        <Route exact path="/week" element={<WeekReport/>}/>
        <Route exact path="/bigtimeLogin" element={<BigtimeLoginForm />}/>
        <Route exact path="/bigtimeEntries/:startDate" element={<BigtimeEntriesReport/>}/>
        <Route exact path="/bigtimeEntries" element={<BigtimeEntriesReport/>}/>
        <Route exact path="/notes" element={<Notes/>}/>
        <Route exact path="/login" element={<LoginForm />}/>
        {
          token == null
            ? <Route exact path="/" element={<LoginForm/>}/>
            : <Route exact path="/" element={<Events/>}/>
        }
      </Routes>
    </BrowserRouter>
  );
}

ReactDOM.render(<App/>, document.getElementById('root'));